import type { LevelRun } from '../../core/level-runner';
import { SIM_HZ } from '../../data/tuning';
import { t } from '../../i18n/es';
import { reactionVisible } from './boss-reaction-model';

/**
 * The "Es harina" bubble next to the boss (GDD §9.1, §13.4, issue #96): a DOM overlay with the catalog text, hidden
 * outside the fight and 3 s of simulation after the last decoy hit. It appears in 140 ms (0 ms with reduced
 * motion, by the global rule of the styles) and never uses red or emoji. It touches the DOM only when it changes.
 */
export function bossReactionBubble(): { element: HTMLElement; update(run: LevelRun | null): void } {
  const element = document.createElement('div');
  element.className = 'boss-reaction';
  element.hidden = true;
  element.setAttribute('role', 'status');
  element.textContent = t('voice.decoy.flour');
  return {
    element,
    update(run) {
      const visible = run?.decoys ? reactionVisible(run.core.tick, run.decoys.lastHitTick, SIM_HZ) : false;
      if (element.hidden === visible) element.hidden = !visible;
    },
  };
}
